import { useContext, useEffect, useState, useCallback } from 'react';
import iconHorasDeTrabajo from 'assets/images/reportes/horas-de-trabajo.svg';
import iconSalario from 'assets/images/reportes/salario.svg';
import iconParidadMujeres from 'assets/images/reportes/paridad-mujeres.svg';
import serviceCommons from 'services/commons';
import empresasService from 'services/empresas';
import { formatoANumeroIngles } from 'helpers/formateoNumeros';
import { AuthContext } from 'context';
import { ICON_NUMERO_TRANSACCIONES } from 'icons/ReporteIndicadores/IconNumeroTransacciones';
import { ICON_RESIDUO_VALORIZADO } from 'icons/ReporteIndicadores/IconResiduoValorizado';
import { ICON_CAMBIO_CLIMATICO } from 'icons/ReporteIndicadores/IconCambioClimatico';
import { ICON_MATERIAL_PARTICULADO } from 'icons/ReporteIndicadores/IconMaterialParticulado';
import { ICON_DEMANDA_ACUMULADA } from 'icons/ReporteIndicadores/IconDemandaAcumulada';
import { PERMISOS } from 'const/Permisos';
import { DICTONARY } from 'const/Dictonary';
import { limpiaParametrosVacios } from 'helpers/manejoLLamadasServicios';

export const useReporte = () => {
  const {
    sucursalNoAdministrada,
    logeduser,
    isTienePermisos,
    perfiles: { isSuperAdmin }
  } = useContext(AuthContext);

  const conIndicadores =
    logeduser?.sucursal?.consumoCombustible !== null && //TODO: modificar en caso que vengan varias sucursales
    logeduser?.sucursal?.consumoEnergetico !== null &&
    logeduser?.sucursal?.trabajadoresMasculino !== null &&
    logeduser?.sucursal?.trabajadoresFemenino !== null
      ? true
      : false;

  const [isLoading, setIsLoading] = useState(true);
  const [resumenIndicadores, setResumenIndicadores] = useState({
    demanda: [],
    oferta: []
  });

  const ESTADO_INICIAL_INDICADOR = {
    marketplace: {
      aside: [],
      principal: []
    },
    gestiona: {
      aside: [],
      principal: []
    },
    horasDeTrabajo: null,
    paridadMujeres: null,
    salario: null,
    state: 'IDLE'
  };

  const [indicadores, setIndicadores] = useState(ESTADO_INICIAL_INDICADOR);

  // Empresas
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState(null);
  const [empresas, setEmpresas] = useState([]);
  const [isLoadingEmpresas, setIsLoadingEmpresas] = useState(false);
  // Grupos
  const [grupoSeleccionado, setGrupoSeleccionado] = useState(null);
  const [grupos, setGrupos] = useState([]);
  const [isLoadingGrupos, setIsLoadingGrupos] = useState(false);
  //  Logica para determinar si se tiene permisos para mostrar filtros de empresas y grupos
  const isLogicaPermisos =
    isTienePermisos(PERMISOS.administracionSucursales) ||
    isTienePermisos(PERMISOS.sucursales);
  const isTieneUnaEmpresa =
    sucursalNoAdministrada.sucursal?.empresa?.codigoEmpresa !== null;

  const renderEstadisticas = data => {
    setIndicadores({
      marketplace: {
        aside: [
          {
            titulo: 'Nº TRANSACCIONES',
            descripcion: 'Transacciones',
            icon: <ICON_NUMERO_TRANSACCIONES />,
            valor: data.transaccion
              ? formatoANumeroIngles(data.transaccion.toString())
              : '-'
          },
          {
            titulo: 'RESIDUOS VALORIZADOS',
            descripcion: 'ton',
            icon: <ICON_RESIDUO_VALORIZADO />,
            valor: data.residuo?.valorizado
              ? formatoANumeroIngles(data.residuo.valorizado.toString())
              : '-'
          }
        ],
        destacado: {
          titulo: 'CAMBIO CLIMÁTICO',
          descripcion: 'kg CO2eq',
          icon: <ICON_CAMBIO_CLIMATICO />,
          valor: data?.ambiental?.marketplace.ambientalCambioClimatico
            ? formatoANumeroIngles(
                data.ambiental.marketplace.ambientalCambioClimatico.toString()
              )
            : '-'
        },
        principal: [
          {
            titulo: 'AGOTAMIENTO DE RECURSO FÓSIL',
            descripcion: 'kg petróleo eq',
            icon: <ICON_CAMBIO_CLIMATICO />,
            valor: data.ambiental.marketplace.ambientalRecursoFosil
              ? formatoANumeroIngles(
                  data.ambiental.marketplace.ambientalRecursoFosil.toString()
                )
              : '-'
          },
          {
            titulo: 'FORMACIÓN DE MATERIAL PARTICULADO',
            descripcion: 'kgmp 2,5eq',
            icon: <ICON_MATERIAL_PARTICULADO />,
            valor: data.ambiental.marketplace.ambientalMaterialParticulado
              ? formatoANumeroIngles(
                  data.ambiental.marketplace.ambientalMaterialParticulado.toString()
                )
              : '-'
          },
          {
            titulo: 'DEMANDA ACUMULADA DE ENERGÍA',
            descripcion: 'MJ eq',
            icon: <ICON_DEMANDA_ACUMULADA />,
            valor: data.ambiental.marketplace.ambientalDemandaAcumulada
              ? formatoANumeroIngles(
                  data.ambiental.marketplace.ambientalDemandaAcumulada.toString()
                )
              : '-'
          }
        ]
      },
      gestiona: {
        aside: [
          {
            titulo: 'Nº DECLARACIONES',
            descripcion: 'declaraciones',
            icon: <ICON_NUMERO_TRANSACCIONES />,
            valor: data.declarado
              ? formatoANumeroIngles(data.declarado.toString())
              : data.declarado
          },
          {
            titulo: 'RESIDUOS DECLARADOS',
            descripcion: 'ton',
            icon: <ICON_RESIDUO_VALORIZADO />,
            valor: data.residuo?.declarado
              ? formatoANumeroIngles(data.residuo.declarado.toString())
              : data.residuo.declarado
          }
        ],
        destacado: {
          titulo: 'CAMBIO CLIMÁTICO',
          descripcion: 'kg CO2eq',
          icon: <ICON_CAMBIO_CLIMATICO />,
          valor: data.ambiental.gestiona.ambientalCambioClimatico
            ? formatoANumeroIngles(
                data.ambiental.gestiona.ambientalCambioClimatico.toString()
              )
            : '-'
        },
        principal: [
          {
            titulo: 'AGOTAMIENTO DE RECURSO FÓSIL',
            descripcion: 'kg petróleo eq',
            icon: <ICON_CAMBIO_CLIMATICO />,
            valor: data.ambiental.gestiona.ambientalRecursoFosil
              ? formatoANumeroIngles(
                  data.ambiental.gestiona.ambientalRecursoFosil.toString()
                )
              : '-'
          },
          {
            titulo: 'FORMACIÓN DE MATERIAL PARTICULADO',
            descripcion: 'kgmp 2,5eq',
            icon: <ICON_MATERIAL_PARTICULADO />,
            valor: data.ambiental.gestiona.ambientalMaterialParticulado
              ? formatoANumeroIngles(
                  data.ambiental.gestiona.ambientalMaterialParticulado.toString()
                )
              : '-'
          },
          {
            titulo: 'DEMANDA ACUMULADA DE ENERGÍA',
            descripcion: 'MJ eq',
            icon: <ICON_DEMANDA_ACUMULADA />,
            valor: data.ambiental.gestiona.ambientalDemandaAcumulada
              ? formatoANumeroIngles(
                  data.ambiental.gestiona.ambientalDemandaAcumulada.toString()
                )
              : '-'
          }
        ]
      },
      horasDeTrabajo: {
        titulo: 'HORAS DE TRABAJO',
        descripcion: 'H totales',
        icon: iconHorasDeTrabajo,
        valor: data.social.indicador.horasTrabajo
          ? formatoANumeroIngles(data.social.indicador.horasTrabajo.toString())
          : data.social.indicador.horasTrabajo
      },
      paridadMujeres: {
        titulo: 'PARIDAD MUJERES',
        descripcion: 'HM',
        icon: iconParidadMujeres,
        valor: data.social.indicador.horasTrabajoMujer
          ? formatoANumeroIngles(
              data.social.indicador.horasTrabajoMujer.toString()
            )
          : data.social.indicador.horasTrabajoMujer
      },
      salario: {
        titulo: 'SALARIO',
        descripcion: 'Mil pesos',
        icon: iconSalario,
        valor: data.social.indicador.salario
          ? formatoANumeroIngles(data.social.indicador.salario.toString())
          : data.social.indicador.salario
      },
      state: 'LOADED'
    });
  };

  /**
   * Cargar las empresas asociadas al grupo seleccionado
   * @function cargarListaEmpresas
   * @params
   *
   * obtenerListaEmpresas
   *  - codigoGrupo: Opcional. Se usa para filtro de datos. *
   *  - nombreEmpresa: Opcional. Se usa para filtro de datos. *
   *  - asociados: true o false. Se usa para indicar si las empresas deben estar filtradas por las que el usuario tiene permiso en sus sucursales.
   */
  const cargarListaEmpresas = useCallback(async () => {
    setIsLoadingEmpresas(true);

    const params = {
      codigoGrupo: grupoSeleccionado?.codigoGrupo,
      asociados: !isSuperAdmin // Indica que las empresas deben estar filtradas por las que el usuario tiene permiso en sus sucursales.
    };
    // Filtrar parámetros nulos
    const filteredParams = limpiaParametrosVacios(params);

    try {
      const response = await empresasService.obtenerListaEmpresas(
        filteredParams
      );
      if (response.data.error) {
        throw new Error('ERROR_AL_CARGAR_EMPRESAS');
      }
      const empresasAux = response.data.map(empresa => ({
        codigoEmpresa: empresa.codigoEmpresa,
        nombreEmpresa: empresa.nombreEmpresa
      }));

      setEmpresas(empresasAux);
    } catch (error) {
      console.error('Error al cargar las empresas:', error);
      setEmpresas([]);
    } finally {
      setIsLoadingEmpresas(false);
    }
  }, [grupoSeleccionado?.codigoGrupo, isSuperAdmin]);

  const cargarListaGrupos = useCallback(async () => {
    setIsLoadingGrupos(true);

    try {
      const response = await empresasService.obtenerListaGrupos({
        totalPagina: DICTONARY.PAGINACION.ALL_DATA,
        ordenarPor: 'nombreGrupo'
      });

      if (response.data.error) {
        throw new Error('ERROR_AL_CARGAR_GRUPOS');
      }
      setGrupos(response.data);
    } catch (error) {
      console.error('Error al cargar los grupos:', error);
      setGrupos([]);
    } finally {
      setIsLoadingGrupos(false);
    }
  }, []);

  const cargaIndicadores = async () => {
    console.log('cargaIndicadores');
    try {
      // se evita que se llame a la api si no se ha seleccionado una empresa
      if (isLogicaPermisos && !empresaSeleccionada && !grupoSeleccionado) {
        return;
      }
      // console.log(grupoSeleccionado);
      setIsLoading(true);
      const queryIndicadores = {
        tipoIndicador: 'todos'
      };

      // Se asigna el codigoGrupo si existe
      queryIndicadores.codigoGrupo =
        grupoSeleccionado && isLogicaPermisos
          ? grupoSeleccionado.codigoGrupo
          : null;

      // Se asigna el codigoEmpresa si existe
      queryIndicadores.codigosEmpresa =
        empresaSeleccionada && isLogicaPermisos
          ? empresaSeleccionada.codigoEmpresa
          : sucursalNoAdministrada.sucursal?.empresa?.codigoEmpresa;

      const response = await serviceCommons.indicadores(
        queryIndicadores,
        DICTONARY.INTERCEPTOR.ACTIVADO
      );
      if (response.status === 200) {
        renderEstadisticas(response.data);
        setResumenIndicadores(response.data.resumen);
      }
    } catch (error) {
      console.log('Error en cargaIndicadoresIniciales ', error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    // console.log('useEffect');
    if (isLogicaPermisos || isTieneUnaEmpresa) {
      cargaIndicadores();
    }
  }, [empresaSeleccionada, grupoSeleccionado]);

  useEffect(() => {
    if (isLogicaPermisos) {
      cargarListaEmpresas();
      cargarListaGrupos();
    }
  }, []);

  return {
    isLoading,
    isSuperAdmin,
    // Indicadores
    indicadores,
    setIndicadores,
    ESTADO_INICIAL_INDICADOR,
    conIndicadores,
    cargaIndicadores,
    resumenIndicadores,
    // Empresas
    empresas,
    empresaSeleccionada,
    isLoadingEmpresas,
    setEmpresaSeleccionada,
    cargarListaEmpresas,
    // Grupos
    grupos,
    grupoSeleccionado,
    setGrupoSeleccionado
  };
};
